import { Link } from 'react-router-dom';
import { hotRankings, movies } from '@/mocks/movies';

const changeIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  down: 'ri-arrow-down-line',
  new: 'ri-flashlight-line',
};

const changeColors: Record<string, string> = {
  up: 'text-accent-500',
  down: 'text-secondary-500',
  new: 'text-primary-500',
};

export default function TrendingList() {
  return (
    <div className="bg-background-800/50 rounded-lg p-5 border border-background-700/30">
      <div className="flex items-center justify-between mb-5">
        <h3 className="font-heading text-lg font-semibold text-foreground-100 flex items-center gap-2">
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-fire-line text-accent-500"></i>
          </div>
          热门排行
        </h3>
        <Link
          to="/category/all"
          className="text-primary-400 hover:text-primary-300 text-xs font-medium transition-colors cursor-pointer whitespace-nowrap"
        >
          查看全部
        </Link>
      </div>
      <div className="space-y-1">
        {hotRankings.map((item) => {
          const movie = movies.find((m) => m.id === item.movieId);
          if (!movie) return null;
          return (
            <Link
              key={item.rank}
              to={`/article/${movie.id}`}
              className="flex items-center gap-3 p-3 rounded-lg hover:bg-background-700/40 transition-colors cursor-pointer group"
            >
              {/* Rank */}
              <div className="w-8 flex-shrink-0 text-center">
                <span
                  className={`text-lg font-bold font-heading ${
                    item.rank <= 3
                      ? 'text-primary-500'
                      : 'text-foreground-500'
                  }`}
                >
                  {item.rank}
                </span>
              </div>
              {/* Poster thumbnail */}
              <div className="w-12 h-16 rounded-md overflow-hidden flex-shrink-0">
                <img
                  src={movie.poster}
                  alt={movie.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              {/* Info */}
              <div className="flex-1 min-w-0">
                <h4 className="text-foreground-200 text-sm font-medium group-hover:text-primary-400 transition-colors line-clamp-1">
                  {movie.title}
                </h4>
                <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-primary-500 text-[10px]"></i>
                    </div>
                    {movie.rating}
                  </span>
                  <span className="text-background-600">|</span>
                  <span>{movie.views > 10000 ? `${(movie.views / 10000).toFixed(1)}万` : movie.views}次播放</span>
                </div>
              </div>
              {/* Change indicator */}
              <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                <i className={`${changeIcons[item.change]} ${changeColors[item.change]} text-sm`}></i>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}